import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, AlertTriangle } from "lucide-react";
import { Button } from "../components/ui/button";
import { usePaymentStatus } from "../hooks/usePaymentStatus";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const { state, amount, kind } = usePaymentStatus(params.get("session_id"));
  const isCart = kind === "cart";

  return (
    <div className="min-h-screen bg-cream flex items-center justify-center px-4" data-testid="payment-success-page">
      <div className="max-w-md w-full bg-white rounded-3xl border border-[#EFE9E0] p-8 sm:p-10 text-center shadow-[0_30px_70px_-50px_rgba(45,40,37,0.5)]">
        {state === "checking" && (
          <>
            <Loader2 size={48} className="mx-auto text-olive animate-spin" />
            <h1 className="mt-4 font-serif text-2xl text-ink">Confirming your payment…</h1>
            <p className="mt-2 text-sm text-[#524B46]">Hang tight, this only takes a moment.</p>
          </>
        )}

        {state === "paid" && (
          <>
            <CheckCircle2 size={56} className="mx-auto text-olive" data-testid="payment-success-icon" />
            {isCart ? (
              <>
                <h1 className="mt-4 font-serif text-3xl text-ink">Order confirmed!</h1>
                <p className="mt-3 text-[#524B46]" data-testid="payment-success-message">
                  Thank you{amount != null ? ` — your $${amount.toFixed(2)} order is confirmed` : ""}. We've emailed
                  you a receipt and will let you know when it's ready for pickup or on its way for delivery.
                </p>
              </>
            ) : (
              <>
                <h1 className="mt-4 font-serif text-3xl text-ink">Deposit received!</h1>
                <p className="mt-3 text-[#524B46]" data-testid="payment-success-message">
                  Thank you{amount != null ? ` — your $${amount.toFixed(2)} deposit is confirmed` : ""}. Your celebration
                  cake date is reserved. We'll email you shortly to finalise the details.
                </p>
              </>
            )}
          </>
        )}

        {state === "pending" && (
          <>
            <Loader2 size={48} className="mx-auto text-olive" />
            <h1 className="mt-4 font-serif text-2xl text-ink">Payment processing</h1>
            <p className="mt-3 text-[#524B46]">
              Your payment is still being processed. We'll confirm your reservation by email as soon as it clears.
            </p>
          </>
        )}

        {state === "error" && (
          <>
            <AlertTriangle size={48} className="mx-auto text-terracotta" />
            <h1 className="mt-4 font-serif text-2xl text-ink">We couldn't confirm your payment</h1>
            <p className="mt-3 text-[#524B46]">
              If you were charged, don't worry — reach out and we'll sort it out right away.
            </p>
          </>
        )}

        <Link to="/">
          <Button
            data-testid="payment-success-home"
            className="mt-8 w-full h-12 rounded-full bg-olive hover:bg-olive-hover text-cream"
          >
            Back to Home
          </Button>
        </Link>
      </div>
    </div>
  );
}
